export interface AppliedFilterOption {
  categoryName?: string
  optionName?: {
    name?: string
    urlName?: string
  }
}

export function buildFilteredPageTitle({ baseTitle, requestedValues, appliedOptions, searchTerm }: {
  baseTitle?: string
  requestedValues?: string[]
  appliedOptions?: AppliedFilterOption[]
  searchTerm?: unknown
}): string | undefined {
  if (!baseTitle || searchTerm || requestedValues?.length !== 1 || appliedOptions?.length !== 1) {
    return baseTitle
  }

  const optionName = appliedOptions[0]?.optionName?.name?.trim()

  return optionName ? `${optionName} ${baseTitle}` : baseTitle
}
